import React, { memo } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import * as moment from "moment";
import { getVehicleIcon } from "../../../../../../includes/util";
import * as globalVariables from "../../../../../../includes/variables";
const VehicleBlockItem = ({
  item,
  isActive,
  clickedVehicle,
  clickedHistory,
}) => {

  const onVehicleClicked = () => {
    clickedVehicle(item);
  };

  const getOdometer = () => {
    //console.log('getOdometer');
    let distance = item.Odometer;
    distance = ("000000" + distance).slice(-10, -4);
    //distance = distance.slice(0, 9);
    return distance.split("").map((odo, i) => (
      <span key={`odo_${i}`} className="odo-number mr-1">
        {odo}
      </span>
    ));
  };

  return (
    <React.Fragment>
      <div className="media p-3 vehicle-detail">

        <div className="media-body  vihicle-info shadow-sm">
          <div style={{ minHeight: "80px" }}
            className={`row align-items-center no-gutters mapDetail ${isActive && "active"}`}
          >

            <div
              className="col-sm-4 d-flex justify-content-center cursor-pointer"
              onClick={onVehicleClicked}
            >
              <div>
                <div className="s-icons col-12  d-flex flex-row justify-content-center">
                  <span className="vehicle-icon">
                    <img
                      src={getVehicleIcon(item.RucMonkeyVehicleTypeId)}
                      alt="vehicleType"
                    />

                  </span>
                </div>
                <div className="d-flex align-items-center p-number">
                  <span className="ml-2">{item.VehiclePlate}</span>
                </div>
              </div>
            </div>
            <div
              className="col-sm-4  p-3 cursor-pointer"
              onClick={onVehicleClicked}
            >
              <div className="row no-gutters d-flex ">

                <div className=" remaining">
                  <span className="info-sub-head">{item.VehicleCode}</span>
                  <br />
                  <span className="info-sub-head">{item.FleetName}</span>
                </div>
              </div>
            </div>
            <div className="col-sm-3 p-3 ">
              <div className="row">
                <div className="col-12">
                  <div className="odo-meter">{getOdometer()}</div>
                </div>
                <div className="col-12  d-flex flex-row justify-content-center">
                  <span
                    className="cursor-pointer mr-1"
                    onClick={clickedHistory}
                  >
                    <Tooltip
                      title={
                        <React.Fragment>
                          {moment(item.OdometerReadingTimestamp).fromNow()} <br />
                          {item.LocationDescription}
                        </React.Fragment>
                      }
                      interactive
                    >
                      <img
                        src={globalVariables.imgPath.location}
                        style={{ height: 23 }}
                        className="ml-3"
                        alt="location"
                      />
                    </Tooltip>
                  </span>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(VehicleBlockItem);
